import { forwardRef, Input, InputProps } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { FormField, FormFieldProps } from "./field";
import { makeFormInputDefaultProps } from "./styles";

export interface FormInputProps extends PropsWithChildren<InputProps> {
  name: string;
  formName: string;
  type: string;
  label?: string;
  placeholder?: string;
  required: boolean;
  controlSx?: Omit<FormFieldProps, "isRequired">;
}

export const FormInput = forwardRef(
  (
    {
      name,
      formName,
      type,
      label,
      placeholder,
      required,
      controlSx,
      ...rest
    }: FormInputProps,
    ref: any,
  ) => {
    return (
      <FormField
        {...controlSx}
        isRequired={required || false}
        label={label}
        labelSx={{
          htmlFor: formName,
          ...controlSx?.labelSx,
        }}
      >
        <Input
          {...makeFormInputDefaultProps(rest?.focusBorderColor)}
          {...rest}
          ref={ref}
          name={formName}
          id={formName}
          type={type.toLowerCase()}
          placeholder={placeholder}
        />
      </FormField>
    );
  },
);
